export default __webpack_public_path__ + "static/media/doubleJump_DP.efeea491.png";